<template>
  <div class="main-div">
    <v-header title="ESG报告"></v-header>
    <div class="performanceReportTop">
      <el-form :inline="true" :model="formInline" ref="formInline" :rules="rules" class="demo-form-inline formBox">
        <el-form-item label="报告名称" prop="reportName">
          <el-input v-model="formInline.reportName"></el-input>
        </el-form-item>
        <el-form-item class="onSubmit">
          <el-button type="primary" :loading="loadings" @click="getEGSList()">查询</el-button>
          <el-button type="default" :loading="loadings" @click="resetFunc()">重置</el-button>
        </el-form-item>
        <el-form-item class="onSubmit sampleClick">
          <a href="#" @click="sampleClick">EGS示例介绍</a>
        </el-form-item>
      </el-form>
    </div>
    <div class="middleDataTable">
      <div class="tableTop">
        <span>EGS报告列表</span>
        <el-button type="primary" @click="addReport">新建报告</el-button>
      </div>
      <!-- 表格 -->
      <el-table :data="teamPersons" style="width: 100" :border="false" :fit="true">
        <el-table-column
          prop="title"
          label="报告名称"
          min-width="120"
          align="center">
        </el-table-column>
        <el-table-column
          prop="createUser"
          label="创建人"
          min-width="180"
          align="center">
        </el-table-column>
        <el-table-column
          prop="createDate"
          label="创建时间"
          min-width="100"
          align="center">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="100"
          align="center">
          <template slot-scope="scope">
            <el-button @click="compileClick(scope.row)" type="text" size="small">编辑</el-button>
            <el-button type="text" size="small" @click="deleteClick(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-row type="flex" class="row-bg" justify="center">
        <el-col class="pages">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            layout="total, prev, pager, next, jumper"
            :total="itemCount">
          </el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import url from '@/modules/url'
import api from '@/modules/api'
import getIP from '@/components/utils/getIP'
import vHeader from '@/layout/Header1.vue'

export default {
  components: {vHeader},
  data() {
    let str = /^[a-zA-Z0-9_\u4e00-\u9fa5]+$/
    var reportNames = (rule, value, callback) => {
      let msg = this.test(value)
      if (!value) {
        return;
      } else if (!str.test(value)) {
        callback(new Error('报告名称只可输入数字字母汉字'));
        return;
      } else if (msg.hz * 2 + msg.fhz * 2 > 60) {
        callback(new Error('报告名称不可超过30个中文字符'));
        return;
      } else {
        callback();
      }
    };
    var names = (rule, value, callback) => {
      let msg = this.test(value)
      if (!value) {
        return;
      } else if (!str.test(value)) {
        callback(new Error('报告名称只可输入数字字母汉字'));
        return;
      } else if (msg.hz * 2 + msg.fhz * 2 > 60) {
        callback(new Error('报告名称不可超过30个中文字符'));
        return;
      } else {
        callback();
      }
    };
    return {
      formInline: {
        reportType: '全部',
        reportName: ''
      },
      currentPage: 1,
      itemCount: 0,
      teamPersons: [],
      loadings: false,
      show: false,
      fileShow: true,
      title: '新建报告',
      report: {
        name: '',
        type: ''
      },
      fileList: [],
      fileName: '',
      fileUrl: '',
      id: '',
      rules: {
        reportName: [
          {validator: reportNames, trigger: 'change'}
        ]
      },
      reportLules: {
        name: [
          {validator: names, trigger: 'change'}
        ]
      }
    };
  },
  watch: {},
  methods: {
    sampleClick() {
      console.log('我点击了ESG示例介绍')
      this.$router.push('/ESGExampleShow')
    },
    test(str) {
      var reg1 = /([\u4e00-\u9fa5]*)/g
      var reg2 = /([\dA-Za-z]*)/g
      return {
        'hz': str.match(reg1).join('').length,
        'fhz': str.match(reg2).join('').length
      }
    },
    // 整个页面的加载
    loading() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      setTimeout(() => {
        loading.close()
      }, 1000)
    },
    addReport() {
      console.log('新建报告')
      this.$router.push('/ESGAdd')
    },
    // 获取表格数据
    getEGSList() {
      let params = {
        reportType: '', // 报告类型
        reportName: '', // 报告名称
        pageParamReqVo: {
          pageCount: 10, // 每页条数
          page: 1 // 当前页
        }
      }
      api.post(url.getTeamPerformanceReportPC, params, res => {
        if (res.result.isSuccess) {
          this.loading()
          sessionStorage.setItem('teamCode', res.data.teamCode)
          let params = {
            title: this.formInline.reportName,
            currentPage: this.currentPage,
            pageSize: 10,
            teamCode: res.data.teamCode
          }
          console.log('params', params)
          this.loadings = true;
          api.post(url.getEsgReports, params, res => {
            console.log('res', res)
            if (res.result.isSuccess) {
              this.loading()
              this.loadings = false;
              this.teamPersons = res.data.list;
              this.itemCount = res.data.total
            } else {
              this.$message({
                type: 'error',
                message: res.result.error
              });
            }
          })
        }
      })
    },
    resetFunc() {
      this.formInline.reportName = ''
      this.getEGSList()
    },
    // 删除
    deleteClick(v) {
      this.$confirm('此操作将永久删除该报告, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          id: v.id
        }
        console.log('params', params)
        api.post(url.deleteEsgReports, params, res => {
          console.log('res删除', res);
          if (res.result.isSuccess) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.getEGSList()
          } else {
            this.$message({
              type: 'error',
              message: res.result.error
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    compileClick(v) {
      console.log('编辑')
      let params = {
        id: v.id
      };
      api.post(url.getEsgReportDetail, params, res => {
        console.log('res编辑', res)
        if (res.result.isSuccess) {
          this.loading()
          this.$router.push({name: 'ESGAdd', query: {list: res.data}})
        } else {
          this.$message({
            type: 'error',
            message: res.result.error
          });
        }
      })
    },
    handleCurrentChange(c, p) {
      this.currentPage = c
      this.getEGSList()
    }
  },
  activated() {
    this.getEGSList()
  }
}
</script>

<style scoped>
.main-div {
  height: 100%;
  width: 96%;
  margin: 0 auto;
}

.performanceReportTop {
  margin-top: 90px;
}

.performanceReportTop .formBox {
  display: flex;
  justify-content: flex-start;
}

/* .performanceReportTop .onSubmit {
  margin-left: 30%;
} */
.performanceReportTop .onSubmit button {
  width: 96px;
}

.middleDataTable .tableTop {
  width: 100%;
  height: 50px;
  background: #ccc;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
}

.pages {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  height: 100px;
}

.reportNameClass {
  display: flex;
}

.reportNameClass /deep/ .el-form-item__label {
  width: 15%;
  text-align: left;
}

.reportNameClass /deep/ .el-form-item__content {
  width: 70%;
}

.reportTypeClass {
  display: flex;
}

.reportTypeClass /deep/ .el-form-item__label {
  width: 15%;
  text-align: left;
}

.reportTypeClass /deep/ .el-form-item__content {
  width: 50%;
}

.upload-demo {
  padding: 5% 15%;
}

.tag {
  margin-left: 5px;
}

.el-upload__tip {
  margin-top: 10px;
  color: red;
}

.dialog-footer {
  display: flex;
  justify-content: space-around;
  padding: 0 20%;
}

.performanceReportTop >>> .el-form--inline .el-form-item {
  margin-right: 80px;
}

.sampleClick {
  margin-left: 300px;
}
</style>



// WEBPACK FOOTER //
// src/pages/performance/ESGadministration.vue